@use '../@shared/mixins' as *;
@use '../../styles/global' as *;
@use '../host-display-block' as *;
@use '../../functional-components/Collapsible/collapsible' as *;

@layer kol-component {
	.kol-details {
		&__heading-button {
			display: flex;

			.kol-button {
				min-height: auto;

				.kol-span {
					&__label {
						border-bottom-color: grey;
						border-bottom-style: solid;
					}
				}
			}
		}

		.collapsible--open &__heading-button {
			.kol-icon::part(icon) {
				transform: rotate(90deg);
			}
		}
	}
}
